import { useMutation } from '@tanstack/react-query'
import type { DiscoveredPage } from '../types'
import { serverURL } from '../api/config'

async function discoverPages(
  token: string,
  orgUuid: string,
  website: string
): Promise<DiscoveredPage[]> {
  // Ensure protocol so the backend can navigate via Playwright
  const normalizedWebsite = website.startsWith('http') ? website : `https://${website}`
  const response = await fetch(
    `${serverURL}/orgs/${orgUuid}/discover-pages`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ website: normalizedWebsite }),
    }
  )
  if (!response.ok) {
    // Non-critical — return empty on failure
    return []
  }
  const data = await response.json()
  return data.pages ?? []
}

export function useDiscoverPages() {
  return useMutation({
    mutationFn: ({
      token,
      orgUuid,
      website,
    }: {
      token: string
      orgUuid: string
      website: string
    }) => discoverPages(token, orgUuid, website),
  })
}
